import { Button, Input, InputError } from '@foodsby/nutrient'
import currency from 'currency.js'
import React, { useEffect, useState } from 'react'

import { submitGift } from '../../api/api'
import { normalizeErrorResponse } from '../../util/errorUtils'
import { pushSnowplow, toOrderProcessSchema } from '../../util/snowplow'
import { Submitting } from '../common/Submitting'

const RemoveAppliedGift = ({
  applyGift,
  loading,
  storedCurrencyBalance,
  storedCurrencyBalanceUsed,
}) => {
  return (
    <div className="Input Input--attached">
      <label htmlFor="gift">Gift Applied</label>
      <div className="Input--attachedSet ">
        <p className="Input-mockInput">
          {currency((storedCurrencyBalanceUsed / 100).toFixed(2), {
            formatWithSymbol: true,
          }).format()}
        </p>

        {loading ? (
          <Submitting text="Changing" />
        ) : (
          <Button
            className="button secondary"
            onClick={e => {
              e.preventDefault()
              applyGift(0)
            }}
            type="button"
          >
            Change
          </Button>
        )}
      </div>
      {storedCurrencyBalance ? (
        <label htmlFor="gift">
          Total gift balance available:{' '}
          {currency(
            (storedCurrencyBalance / 100).toFixed(2) - (storedCurrencyBalanceUsed / 100).toFixed(2),
            {
              formatWithSymbol: true,
            },
          ).format()}{' '}
        </label>
      ) : null}
    </div>
  )
}

const AddGift = ({ applyGift, loading, setValue, storedCurrencyBalance, value }) => {
  return (
    <div className="Input Input--attached">
      <div>
        <label htmlFor="gift">Gift Amount</label>
      </div>
      <div className="Input--attachedSet ">
        <Input
          allowNegative={false}
          decimalScale={2}
          displayType="input"
          fixedDecimalScale
          onBlur={() =>
            pushSnowplow(toOrderProcessSchema('daily', 'checkout_gift_amount_enter', value))
          }
          onKeyDown={e => e.keyCode === 13 && applyGift(value)}
          onValueChange={values => setValue(values.value)}
          prefix="$"
          value={value}
        />

        {loading ? (
          <Submitting text="Applying" />
        ) : (
          <Button
            className="button secondary"
            disabled={!value || loading}
            onClick={event => {
              event.preventDefault()
              applyGift(value)
            }}
            type="button"
          >
            Apply
          </Button>
        )}
      </div>
      {storedCurrencyBalance ? (
        <label htmlFor="gift">
          {currency((storedCurrencyBalance / 100).toFixed(2), {
            formatWithSymbol: true,
          }).format()}{' '}
          balance available
        </label>
      ) : null}
    </div>
  )
}

export const Gifts = ({
  dropoffId,
  isSubscribed,
  loadCheckoutCartStart,
  orderTotal,
  storedCurrencyUsage,
}) => {
  const [value, setValue] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const applyGift = async giftAmount => {
    setLoading(true)
    try {
      pushSnowplow(
        toOrderProcessSchema('daily', 'checkout_gift_amount_apply', currency(giftAmount).intValue),
      )
      await submitGift(dropoffId, currency(giftAmount).intValue)
      loadCheckoutCartStart(dropoffId, isSubscribed)
      setError(null)
    } catch (e) {
      const error = normalizeErrorResponse(e)
      setError(error)
      pushSnowplow(
        toOrderProcessSchema(
          'daily',
          'checkout_gift_amount_apply',
          currency(giftAmount).intValue,
          error,
        ),
      )
    }
    setLoading(false)
  }

  useEffect(() => {
    setValue(Math.min(storedCurrencyUsage?.storedCurrencyBalance / 100, orderTotal))
  }, [orderTotal, storedCurrencyUsage])

  return (
    <>
      {storedCurrencyUsage?.storedCurrencyApplied ? (
        <RemoveAppliedGift
          applyGift={applyGift}
          loading={loading}
          storedCurrencyBalance={storedCurrencyUsage?.storedCurrencyBalance}
          storedCurrencyBalanceUsed={storedCurrencyUsage?.storedCurrencyBalanceUsed}
        />
      ) : (
        <AddGift
          applyGift={applyGift}
          loading={loading}
          setValue={setValue}
          storedCurrencyBalance={storedCurrencyUsage?.storedCurrencyBalance}
          value={value}
        />
      )}
      <div style={{ marginTop: error ? '-16px' : '0px' }}>
        <InputError className="Input-error">{error}</InputError>
      </div>
    </>
  )
}

export default Gifts
